import React, { useEffect, useState } from 'react';
import { Box, Grid, TextField, Typography  } from "@mui/material";

import "../../assets/Calendrier.scss"
import ApiClient from "../../service/ApiClient";
import { Popup, PopupBody, PopupFooter, PopupHeader, PopupTitle } from "../../component/Popup/Popup";
import AddUpdateSeasonPopup from "./AddUpdateSeasonPopup";
import ReactGA from "react-ga4";
import {useTheme} from "@emotion/react";

export default function Season(props) {
    const theme = useTheme();
    const [search, setSearch] = useState("");
    const [seasons, setSeasons] = useState([]);
    const [actualPage, setActualPage] = useState(0);
    const [nbRow, setNbRow] = useState(200);
    const [confirmPopup, setConfirmPopup] = useState(false);
    const [actualSeason, setActualSeason] = useState(null);
    const [deleteError, setDeleteError] = useState(false);
    const [showPopup, setShowPopup] = useState("");

    const styles = {
        header: {
            backgroundColor: "black",
            color: "white",
            padding: "0.5rem"
        },
        rows: {
            padding: "0.5rem",
            borderBottom: "solid 1px #c7c7c7",
            height: "60px"
        },
        actualRows: {
            padding: "0.5rem",
            borderBottom: "solid 1px #c7c7c7",
            height: "60px",
            backgroundColor: theme.palette.colors.green
        },
        img: {
            height: "100%"
        },
        cssLabel: {
            "&.Mui-focused": {
                color: "#048f00"
            }
        },
    };

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
        (async () => {
            try {
                await loadData();
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);

    async function loadData() {
        try {
            let result = await ApiClient.instance.getSeason();
            setSeasons(result.data);
        } catch (error) {
            console.log(error);
        }
    }

    async function addSeason(data) {
        try {
            await ApiClient.instance.createSeason(data);
            props.createNotification("success", {title: "Succès", message: "Saison créée", timeout: 3000});
            setShowPopup("");
            await loadData();
        } catch (e) {
            props.createNotification("error", {title: "Erreur", message: "Saison non créée", timeout: 3000});
            console.log(e);
        }
    }

    async function updateSeason(data) {
        try {
            await ApiClient.instance.updateSeason(data);
            props.createNotification("success", {title: "Succès", message: "Saison mis à jour", timeout: 3000});
            setShowPopup("");
            await loadData();
        } catch (e) {
            props.createNotification("error", {title: "Erreur", message: "Saison non mis à jour", timeout: 3000});
            console.log(e);
        }
    }

    function buildRowSeason() {
        let rows = [];
        const re =  new RegExp("(" + search + ")\w*", "yi");
        for (let i = actualPage * nbRow; i < (nbRow * (actualPage + 1)) && i < seasons.length; i++) {
            if (!seasons[i].name.search(re)) {
                rows.push(<Grid item container direction={"row"} key={i} sx={seasons[i].defaultSeason ? styles.actualRows : styles.rows}>
                    <Grid item xs><Typography
                        variant={"body1"}>{seasons[i].name}</Typography></Grid>
                    <Grid item sm={2} xs>
                        <button className={"btn btn-sm remove-article"} style={seasons[i].defaultSeason ? {color: 'white'} : {}}
                                onClick={() => {
                                    setActualSeason(seasons[i]);
                                    setConfirmPopup(true);
                                }}><i className="material-icons">delete</i></button>
                        <button className={"btn btn-sm remove-article"} style={seasons[i].defaultSeason ? {color: 'white'} : {}}
                                onClick={() => {
                                    setActualSeason(seasons[i]);
                                    setShowPopup("update");
                                }}><i className="material-icons">edit</i></button>
                    </Grid>
                </Grid>)
            }
        }
        return (<Grid container direction={"column"}>{rows}</Grid>)
    }

    if (seasons.length === 0)
        return (<div/>)
    return (<Box>
        <TextField style={{marginBottom: "1rem"}} inputProps={{min: 0}} InputLabelProps={{classes: {root: styles.cssLabel}}}
                   type={"text"} label={"Rechercher"} onChange={(event) => {
                       setSearch(event.target.value);
                   }}
        />
        <Grid container direction={"column"}>
            <Grid item container direction={"row"} justifyContent={"center"} alignItems={"center"}>
                <Grid sx={styles.header} item xs>
                    <Typography variant={"h6"}>Saison</Typography>
                </Grid>
                <Grid sx={styles.header} container item sm={2} xs justifyContent="flex-end">
                    <Grid item>
                        <Typography variant={"h6"} sx={{paddingRight: '8px'}}>Action</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Box style={{height: "400px", overflow: "auto"}}>
                    {buildRowSeason()}
                </Box>
            </Grid>
        </Grid>
        {showPopup === "create" && <AddUpdateSeasonPopup close={() => setShowPopup("")} submit={addSeason} season={null}/>}
        {showPopup === "update" && <AddUpdateSeasonPopup close={() => setShowPopup("")} submit={updateSeason} season={actualSeason}/>}
        {confirmPopup &&
        <Popup close={() => {
            setConfirmPopup(false);
            setDeleteError(false);
        }}>
            <PopupHeader>
                <PopupTitle>Supprimer une saison</PopupTitle>
            </PopupHeader>
            <PopupBody>
                <p>Voulez-vous vraiment supprimer cette saison ?</p>
                {deleteError && <small className={"text-danger col-12"}>Impossible de supprimer une saison utilisé comme saison actuelle</small>}
            </PopupBody>
            <PopupFooter dismiss={"Non"} close={() => {
                setConfirmPopup(false);
                setDeleteError(false);
            }}>
                <button className={"btn btn-primary"} onClick={async () => {
                    try {
                        await ApiClient.instance.deleteSeason(actualSeason.value);
                        props.createNotification("success", {title: "Succès", message: "Saison supprimée", timeout: 3000});
                        setConfirmPopup(false);
                        setDeleteError(false);
                        await loadData();
                    } catch (e) {
                        props.createNotification("error", {title: "Erreur", message: "Saison non supprimée", timeout: 3000});
                        setDeleteError(true);
                        console.log(e);
                    }
                }}>Oui
                </button>
            </PopupFooter>
        </Popup>}
        <div className={"addArticle"}>
            <button className={"no-button"} onClick={() => {setShowPopup("create")}}>
                <i className="material-icons">add_circle</i>
            </button>
        </div>
    </Box>)
}
